// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Video__Wrapper_RDdWJ grid grid--col-12","VideoFrame":"Video__VideoFrame_1RqWw","Title":"Video__Title_2kW8M","Description":"Video__Description_36ZQq"};